// Action types
export const UPDATE_TRIAGE_ITEMS = 'triage-pane/UPDATE_TRIAGE_ITEMS';
export const UPDATE_TRIAGE_ITEM = 'triage-pane/UPDATE_TRIAGE_ITEM';
export const SET_TRIAGE_USERS = 'triage-pane/SET_TRIAGE_USERS';
export const SET_OPTION_MENU_OPEN = 'triage-pane/SET_OPTION_MENU_OPEN';



// WEBPACK FOOTER //
// ./app/modules/triage/store/action-types.js